import Vue from 'vue'
import Vuex from 'vuex'
import recordModule from './record'
import dataModule from './data'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    record: recordModule,
    datosQR: dataModule
  }
})

export default store